import Entity from "@/store/entities/entity";

export default class DocumentPage extends Entity<number>{
    documentId: number;
    number: number;
    template: string;
}
